import { createResource } from "frappe-ui-src/resources/resources"

export const userResource = createResource({
	url: "frappe.auth.get_logged_user",
	cache: "User",
})
